<template>
  <div id="app">
    <cookie-consent />
    <router-view/>
  </div>
</template>

<script>
// 引入 cookieConsent 组件
import cookieConsent from '@/components/cookieConsent';

import store from './store/index'
export default {
  components: {
    cookieConsent
  },
  mounted() {
    this.setClient()
  },
  methods: {
    setClient() {
      const screenWidth = document.body.offsetWidth
      if (screenWidth < 980) {
        store.dispatch('toggleScreen', false)
      } else {
        store.dispatch('toggleScreen', true)
      }
    }
  }
}
// This starter template is using Vue 3 experimental <script setup> SFCs
// Check out https://github.com/vuejs/rfcs/blob/master/active-rfcs/0040-script-setup.md
</script>
<style lang="less">
#app {
  width: 100%;
  font-family: PingFang SC;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  // text-align: center;
  color: #2c3e50;
}
html, body {
  min-height: 100%;
  font-size: 16px;
  margin: 0;
  padding: 0;
  // background-color: #F6F6F6;
  background: #F6F6F6;
  font-family: PingFang SC;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;

}
p, ul {
  margin: 0;
  padding: 0;
}

html{
  overflow-y: scroll !important; /* 始终显示滚动条轨道 */
}
</style>
